import { formatGradeValue } from './gradebookTypes';
import { QuestionActionDialog } from './QuestionActionDialog';

interface RemoveQuestionDialogProps {
  assignmentTitle: string;
  errorMessage: string | null;
  isPending: boolean;
  // Whether questions after this one are renumbered for students.
  laterQuestionsRenumber: boolean;
  // What the assignment (or, when it has both, this kind of its questions) is
  // worth now, and after the removal.
  newTotal: number;
  onConfirm(): void;
  onOpenChange(open: boolean): void;
  onRestoreFocus(): void;
  open: boolean;
  previousTotal: number;
  questionName: string;
  // Set when the assignment has both kinds of question: which total changes.
  totalOf?: 'homework' | 'pre-lecture questions';
}

function points(value: number) {
  return `${formatGradeValue(value)} ${value === 1 ? 'point' : 'points'}`;
}

/** Asks before removing a question from an assignment for every student. */
export function RemoveQuestionDialog({
  assignmentTitle,
  laterQuestionsRenumber,
  newTotal,
  previousTotal,
  questionName,
  totalOf,
  ...dialogProps
}: RemoveQuestionDialogProps) {
  const subject = totalOf ? `${assignmentTitle}’s ${totalOf}` : assignmentTitle;
  const worth = `${subject} will be worth ${points(newTotal)} instead of ${formatGradeValue(previousTotal)}`;

  return (
    <QuestionActionDialog
      {...dialogProps}
      confirmLabel="Remove question"
      destructive
      pendingLabel="Removing…"
      reassurance="Students’ answers are kept, so you can restore it later."
      summary={`Students won’t see it anymore, and it won’t count toward anyone’s score. ${worth}${laterQuestionsRenumber ? ', and later questions are renumbered' : ''}.`}
      title={`Remove ${questionName} from ${assignmentTitle}?`}
    />
  );
}
